__turbopack_context__.v({
  "active": "SecondaryNavbar-module__k-LvFW__active",
  "content": "SecondaryNavbar-module__k-LvFW__content",
  "contentMobile": "SecondaryNavbar-module__k-LvFW__contentMobile",
  "fadeIn": "SecondaryNavbar-module__k-LvFW__fadeIn",
  "mobileNav": "SecondaryNavbar-module__k-LvFW__mobileNav",
  "mobileNavColumn": "SecondaryNavbar-module__k-LvFW__mobileNavColumn",
  "mobileNavItem": "SecondaryNavbar-module__k-LvFW__mobileNavItem",
  "nav": "SecondaryNavbar-module__k-LvFW__nav",
  "navItem": "SecondaryNavbar-module__k-LvFW__navItem",
  "root": "SecondaryNavbar-module__k-LvFW__root",
  "secondaryNavMobileExpand": "SecondaryNavbar-module__k-LvFW__secondaryNavMobileExpand",
  "sectionTitleVisible": "SecondaryNavbar-module__k-LvFW__sectionTitleVisible",
});
